import { ctaStripStep } from './steps/ctaStrip'
import { removeRecommendationsForCustomerStep } from './steps/recommendationsforCustomerStep'

const controlLoggedOutSteps = [removeRecommendationsForCustomerStep]

const controlLoggedInSteps: typeof controlLoggedOutSteps = []

export const getPipelineSteps = ({
  loggedIn,
}: {
  loggedIn: boolean | null
  region: string
}) => {
  return loggedIn
    ? [...controlLoggedInSteps, ctaStripStep]
    : [...controlLoggedOutSteps, ctaStripStep]
}
